import script from "./select-ajax.vue?vue&type=script&setup=true&lang=js"
export * from "./select-ajax.vue?vue&type=script&setup=true&lang=js"

import "./select-ajax.vue?vue&type=style&index=0&id=9b8d5cc2&lang=css"

const __exports__ = script;

export default __exports__